<script>
    export default {
        props: {
            initialEmployees: {
                type: Number,
                default: null,
            },
            load_stripe_key: {
                type: String,
                default: false,
            },
            client_secret: {
                type: String,
                default: false,
            },
            initialDesigns: {
                type: Number,
                default: 0,
            },
            coupon: {
                type: String,
                default: '',
            },
            couponName: {
                type: String,
                default: '',
            },
            discountAmount: {
                type: Number,
                default: 0,
            },
            user: {
                type: Object,
                default: null,
            },
            organization: {
                type: Object,
                default: null,
            },
        },
        data: function () {
            return {
                //loaded: false,
                //modalTitle: 'Signature Saved',
                purchaseLoading: false,
                purchaseSuccessful: false,
                user_id: null,
                organization_id: null,
                organization_plan: null,
                name: '',
                email: '',
                password: '',
                password_confirmation: '',
                company_name: '',
                purchaseErrors: null,
                token: null,
                error: null,
                stripe: undefined,
                stripeResult: null,
                elements: undefined,
                card: undefined,
                discountFraction: this.discountAmount / 100,
                employees: this.initialEmployees,
                designs: this.initialDesigns,
                style: {
                    base: {
                        color: '#333333',
                        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        '::placeholder': {
                            color: '#999999'
                        }
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a'
                    }
                },
            }
        },
        mounted() {
            //console.log('Component mounted.')
            if (this.load_stripe_key) {
                this.stripe = Stripe(this.load_stripe_key);
            }
            if (this.user && this.organization) {
                this.user_id = this.user.id;
                this.name = this.user.name;
                this.email = this.user.email;
                this.organization_id = this.organization.id;
                this.organization_plan = this.organization.name;
                this.company_name = this.organization.name;
            }
            var self = this;
            self.$nextTick(function () {
                self.elements = self.stripe.elements();
                self.card = self.elements.create('card', {style: self.style});
                self.card.mount(self.$refs.card);
            });
        },
        filters: {
            formatMoney: function(value) {
                var number = parseFloat(value);
                var currencySymbol = '$';
                return currencySymbol + number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            },
        },
        methods: {
            roundedAmount: function() {
                return Math.ceil(this.employees / 10) * 10;
            },
            calculatedSubTotal: function() {
                var closestTen = this.roundedAmount();
                return closestTen;
            },
            calculatedDiscount: function() {
                var closestTen = this.roundedAmount();
                if (this.coupon) {
                    return Math.round(((closestTen * this.discountFraction)) * 100) / 100;
                } else {
                    return 0;
                }
            },
            calculatedTotal: function() {
                var closestTen = this.roundedAmount();
                if (this.coupon) {
                    return Math.round((closestTen - (closestTen * this.discountFraction)) * 100) / 100;
                } else {
                    return closestTen;
                }
            },
            calculatedOneTimeTotal: function() {
                return this.designs * 200;
            },
            purchase: function () {
                var self = this;
                self.purchaseLoading = true;
                self.purchaseErrors = null;
                if (this.stripeResult) {
                    self.savePurchaseData();
                } else {
                    self.stripe.handleCardSetup(self.client_secret, self.card, {
                        payment_method_data: {
                            billing_details: {
                                email: self.accountEmail
                            }
                        }
                    }).then(function(result) {
                        // Handle result.error or result.setupIntent
                        //console.log(result);
                        if (result.error) {
                            console.log(result.error);
                            self.error = result.error.message;
                            self.purchaseLoading = false;
                        } else {
                            //console.log("success!");
                            self.error = null;
                            self.stripeResult = result;
                            //console.log(result);
                            self.savePurchaseData();
                        }
                    });
                }
            },
            savePurchaseData: function() {
                var self = this;
                var object_to_send = {payment_method: self.stripeResult.setupIntent.payment_method, user_id: self.user_id, organization_id: self.organization_id, name: self.name, email: self.email, password: self.password, password_confirmation: self.password_confirmation, company_name: self.company_name, amount: self.employees, coupon: self.coupon, designs: self.designs};
                axios.post('/enterprise/purchase', object_to_send)
                .then(function (response) {
                    //console.log(response);
                    self.purchaseSuccessful = true;
                    self.purchaseLoading = false;
                })
                .catch(function (error) {
                    self.purchaseLoading = false;
                    if (error.response.data.errors) {
                        self.purchaseErrors = error.response.data.errors;
                    } else {
                        console.log(error);
                        console.log(error.response);
                    }
                });
            }
        }
    }
</script>
